export default function cookies() {

    const cookies = document.querySelector('.js-cookies');
    const cookiesAccept = document.querySelector('.js-cookies-accept');

    

    if ( cookies && cookiesAccept ) {

        if ( localStorage.getItem("cookies_accepted") != 'true' ) {
            cookies.classList.add("acitve");
        }

        cookiesAccept.addEventListener('click',function(){
            cookies.classList.remove("acitve");
            localStorage.setItem("cookies_accepted", 'true');
        });

        /* setTimeout(() => {
            localStorage.setItem("cookies_accepted", 'false');
        }, 360000) */

    }

}